/**
 * Created by Yu Zhang on 4/17/17.
 * Description:
 *
 * ------ maintenance history ------
 */
import { userIdReducer, tokenReducer, authMsgReducer, tokenValidReducer } from './auth.reducer';
import { threadFocusReducer } from './thread.reducer';
import {
    threadListReducer, searchAllThreadListReducer, searchCurrentThreadListReducer,
    recentNotesEntityReducer, recentNotesContactReducer
} from './thread-list.reducer';
import { threadMsgReducer } from './thread-msg.reducer';
import {
    entityFocusReducer, entityListReducer, entityMsgReducer,
    entityReducer, templateConfigReducer, createntityReducer,
    slideSheetEntityReducer, templateSlideSheetConfigReducer
} from './entity.reducer';
import { noteFocusReducer, noteMsgReducer, noteBodyFocusReducer, noteReducer, appendEntitiesReducer, appendAllEntitiesReducer, replaceEntityReducer } from './note.reducer';
import { routingValidReducer } from './routing-valid.reducer';
import { contactListReducer, contactMsgReducer, contactReducer } from './contact.reducer';
import { entryTemplateReducerA } from './template.reducer';
import { appStatusReducer } from './app-status.reducer';
import { SmartReducerConfig, SmartReducerService } from '../services/smart-reducer.service';
import { EntityConfigurationConstants } from '../models/smart-reducer.model';

export const smartReducerConfigs = [
    new SmartReducerConfig(entryTemplateReducerA,
        EntityConfigurationConstants.ReducerName,
        EntityConfigurationConstants.AddActionTypeName,
        EntityConfigurationConstants.DeleteActionTypeName,
        EntityConfigurationConstants.ActionKeyName,
        (tabName) => 'EntryTemplate-' + tabName),
];
const service = new SmartReducerService();

const smartReducers = service.generate(smartReducerConfigs);
const originalReducerMap = new Map<string, any>();
originalReducerMap.set(EntityConfigurationConstants.ReducerName, (state) => state[EntityConfigurationConstants.OriginalParentStateName]);
export const smartSelector = smartReducers.getSmartSelector(originalReducerMap, (state) => state['dynamicPages']);
export const smartEffect = smartReducers.getSmartEffectAction;

export const rootReducer = {
    userId: userIdReducer,
    token: tokenReducer,
    authMsg: authMsgReducer,
    appendEntities: appendEntitiesReducer,
    appendAllEntities: appendAllEntitiesReducer,
    replaceEntity: replaceEntityReducer,
    entityFocus: entityFocusReducer,
    entity: entityReducer, // TODO, may need to delete this if nobody is using it.
    slideSheetEntity: slideSheetEntityReducer,
    createEntity: createntityReducer,
    tokenValid: tokenValidReducer,
    threadList: threadListReducer,
    searchAllThreadList: searchAllThreadListReducer,
    searchCurrentThreadList: searchCurrentThreadListReducer,
    recentNotesEntity: recentNotesEntityReducer,
    recentNotesContact: recentNotesContactReducer,
    entityList: entityListReducer,
    threadMsg: threadMsgReducer,
    contactList: contactListReducer,
    contactMsg: contactMsgReducer,
    contact: contactReducer,
    entityMsg: entityMsgReducer,
    templateConfig: templateConfigReducer,
    templateSlideSheetConfig: templateSlideSheetConfigReducer,
    threadFocus: threadFocusReducer,
    noteFocus: noteFocusReducer,
    note: noteReducer,
    noteMsg: noteMsgReducer,
    routingValid: routingValidReducer,
    noteBodyFocus: noteBodyFocusReducer,
    appStatus: appStatusReducer
};

export function getRootReducers() {
    return rootReducer;
}
